import { ComingSoonPage } from './ComingSoonPage';

export function ApiPage() {
    return (
        <ComingSoonPage
            eyebrow="Développeurs"
            title="API & Webhooks"
            icon="code"
            description="Connectez Quotio à vos outils : CRM, automations, Zapier, emails transactionnels."
            features={[
                'Clés API pour vos intégrations',
                'Webhooks sur réception de nouvelles demandes',
                'Endpoints REST pour lire vos générateurs et leads',
                'SDK JavaScript / Node prêt à l\'emploi',
            ]}
        />
    );
}
